import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { RegistrationConfigService } from "../registration.config";

import { AddressByCepResponse } from "./registration-with-cep.model";

@Injectable({
	providedIn: "root",
})
export class RegistrationWithCepService {
	constructor(
		private httpClient: CoreHttpClient,
		private registrationConfig: RegistrationConfigService
	) {}

	getAddressByCep(cep: string): Observable<AddressByCepResponse> {
		return this.httpClient.get<AddressByCepResponse>({
			url: this.registrationConfig.getAddressByCepCodeEndpoint(),
			searchParams: {
				countryCode: "BR",
				postCode: cep,
			},
		});
	}
}
